import Backbone from "backbone";
import DeletePaymentMethodPopinView from "./DeletePaymentMethodPopinView";
import { pathname } from "../../common/others/Configuration";
import $ from "jquery";
import SharedDispatcher from "../../common/others/SharedDispatcher";
import { MagnificPopup } from "../../common/dynamic-imports/MagnificPopup";

export default Backbone.View.extend({

  initialize: function () {
    this.reference = this.$el.data("reference");
    this.isAchatUlterieur = this.$el.data("is-achat-ulterieur");
    this.isTr = this.$el.data("is-tr");
    this.magnificPopup = new MagnificPopup();
    this.tooltipPopup = new MagnificPopup();
    this.listenTo(SharedDispatcher, "paymentMethodContainer:remove", this.removePaymentMethodContainer);
  },

  events: {
    "click .js-remove": "openDeletePopin",
    "click .js-deactivate": "checkUsage",
    "click .js-tooltip": "tooltip",
    "click .js-openpop": "showPopup"
  },

  openDeletePopin: function (targetContainer) {
    const deletePaymentMethodPopin = this.$el.find(".js-deletePaymentMethodPopin");
    if (deletePaymentMethodPopin.length) {
      new DeletePaymentMethodPopinView({
        el: deletePaymentMethodPopin
      });
    }
  },

  checkUsage: function (e) {
    if (this.isAchatUlterieur === "False" || this.isTr === "False") {
      const targetContainer = $(e.currentTarget).parents(".js-removeCCcontainer").get(0); // get corresponding ancestor "js-removeCCcontainer" element
      this.openDeletePopin(targetContainer);
    } else {
      this.deactivate(e);
    }
  },

  deactivate: function (e) {
    const self = this;
    const $target = $(e.currentTarget);
    const dataset = {
      flag: $target.data("flag"),
      label: $target.data("label"),
      disabledLabel: $target.data("disabled-label"),
      reference: $target.data("reference")
    };
    $.ajax({
      type: "POST",
      url: pathname + "/account/api/v1/creditcard/DeleteCreditCardUsage/" + dataset.reference + "-" + dataset.flag,
      success: function () {
        switch (dataset.flag) {
          case 1:
            self.isAchatUlterieur = "False";
            break;
          case 2:
            self.isTr = "False";

            // Open confirmation pop-in with membership payment message
            if ($(".js-disableTacitAgreementPopin").length) {
              self.magnificPopup.open({
                items: {
                  src: `.js-removeCCcontainer[data-reference=${dataset.reference}] .js-disableTacitAgreementPopin`,
                  type: "inline"
                },
                fixedContentPos: true,
                mainClass: "f-mfp"
              });
            }

            break;
        }

        $target.addClass("disabled");
        $target.text(dataset.disabledLabel);
      },
      error: function () {
        SharedDispatcher.trigger("flashmessage:show");
      }
    });
  },

  tooltip: function (event) {
    const tooltipContent = $(event.currentTarget).data("tooltip");

    this.tooltipPopup.open({
      items: {
        src: tooltipContent,
        type: "inline"
      }
    });
  },

  removePaymentMethodContainer: function (ref) {
    const container = $(".js-removeCCcontainer[data-reference=" + ref + "]");
    if (container.length) {
      container.remove();
    }

    if ($(".js-removeCCcontainer").length === 0) {
      location.reload();
    }
  }
});
